import { parse as uuidParse } from 'uuid';

const bufferToBase64 = (buf: ArrayLike<number>) => btoa(
  Array.prototype.map.call(buf, (ch: number) => String.fromCharCode(ch)).join(''),
);

// A session UUID as the server's routes and the documents URL expect it: unpadded base64url
const toSessionIdParam = (id: string) => bufferToBase64(uuidParse(id))
  .replace(/=+$/, '')
  .replace(/\+/g, '-')
  .replace(/\//g, '_');

export default toSessionIdParam;
